module.exports = __webpack_public_path__ + "img/avatar4.1ae73e06.jpg";